export default __webpack_public_path__ + "_/shared_modules/base-layout/img/favicon-a93b7acddb8111a118f805b23e4a8ccf.ico";